import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@doda/pc/src/redux/store';

/**
 * 初期型
 */
export interface RewritesUrlState {
  /** サーバーとクライアントで異なる場合があるため固定するURL */
  rewritesUrl: string;
}

/**
 * 初期状態
 */
export const rewritesUrlInitialState: RewritesUrlState = {
  rewritesUrl: '', // SSRのタイミングでreq.urlを格納
};

/**
 * rewritesUrl スライス
 */
export const rewritesUrlSlice = createSlice({
  name: 'rewritesUrl',
  initialState: rewritesUrlInitialState,
  reducers: {
    setRewritesUrl: (state, action: PayloadAction<string>) => {
      state.rewritesUrl = action.payload;
    },
  },
});

/** アクションを作成 */
export const { setRewritesUrl } = rewritesUrlSlice.actions;

/** リデューサー */
export const rewritesUrlReducer = rewritesUrlSlice.reducer;

/**
 * rewritesUrlを選択するためのセレクタ
 * @param {RootState} state - Reduxの状態
 * @returns {string} current rewritesUrl - 現在のrewritesUrl
 */
export const rewritesUrlSelector = (state: RootState) =>
  state.rewritesUrl.rewritesUrl;
